import moment from 'moment'


const updateDateFormat = (date) => {
  //updates the date format from the browser default YYYY-MM-DD, to DD/MM/YYYY
  let m = moment(date, 'YYYY-MM-DD')
  return m.format('MM/DD/YYYY')
}


const showErrors = (errors, touched) => {
  if(!errors || !touched) return
  return Object.entries(errors).find(([error, val]) => {
    if(typeof val === 'object') {
      return showErrors(val, touched[error])
    }
    return touched[error]
  })
}

export {
  showErrors,
  updateDateFormat
}
